import axios from 'axios';
import { configRefs } from '@utils/constants';

async function getUnicUserData(userId) {
  var _a;
  const response = await axios.get(
    `${(_a = await configRefs.apis.gas.get()) == null ? void 0 : _a.replaceAll(
      "{{version}}",
      "v1"
    )}/api/v1/user/UnicUser/${encodeURIComponent(userId)}`
  );
  const user = {
    id: userId,
    name: `${response.data.FirstName} ${response.data.LastName}`,
    role: mapFunctionDescriptionToUserRole(response.data.FunctionDescription),
    authenticationProvider: "uniLogin"
  };
  if (response.data.InstitutionId && response.data.InstitutionName) {
    user.institution = {
      id: response.data.InstitutionId,
      name: response.data.InstitutionName
    };
    if (user.role === "student") {
      const institutionDetails = await getInstitutionDetailsForStudent(
        user.id,
        user.institution.id
      );
      user.institution.class = institutionDetails.class;
      user.institution.gradeLevel = institutionDetails.gradeLevel;
      if (await isTeacherEducation(user.institution.id)) {
        user.role = "teacher";
      }
    }
  }
  return user;
}
async function getInstitutionDetailsForStudent(userId, institutionId) {
  var _a, _b, _c, _d;
  try {
    const response = await axios.get(
      `${(_a = await configRefs.apis.gas.get()) == null ? void 0 : _a.replaceAll(
        "{{version}}",
        "v1"
      )}/api/v1/Unic/Student/${encodeURIComponent(
        userId
      )}/Institution/${encodeURIComponent(institutionId)}`
    );
    return {
      class: (_c = (_b = response.data) == null ? void 0 : _b.Class) == null ? void 0 : _c.Name,
      gradeLevel: (_d = response.data) == null ? void 0 : _d.GradeLevel
    };
  } catch {
    return {};
  }
}
async function isTeacherEducation(institutionId) {
  var _a;
  try {
    const response = await axios.get(
      `${(_a = await configRefs.apis.gas.get()) == null ? void 0 : _a.replaceAll(
        "{{version}}",
        "v1"
      )}/api/v1/unic/Institution/${encodeURIComponent(institutionId)}`
    );
    return response.data.INST_TYPE_3 === 1085 || response.data.INST_TYPE_3 === "1085";
  } catch {
    return false;
  }
}
function mapFunctionDescriptionToUserRole(functionDescription) {
  if (!functionDescription) {
    return "teacher";
  }
  switch (functionDescription.toLowerCase()) {
    case "elev":
    case "student":
    case "stud":
    case "studerende":
    case "barn":
      return "student";
    default:
      return "teacher";
  }
}

export { getUnicUserData, mapFunctionDescriptionToUserRole };
//# sourceMappingURL=request.get-user-identity.unic.js.map
